export default __webpack_public_path__ + "static/media/banner3.96ac39fe.jpg";